<template>
  <v-card class="rounded-lg white">
    <v-card-title class="secondary--text mb-5">
      {{ title }}
      <v-spacer></v-spacer>
      <v-btn
          v-if="selectedCount"
          depressed
          small
          color="error white--text"
          class="rounded-lg ml-2"
          :loading="bulkLoading"
          @click="bulkModerate('reject')"
      >رد {{ selectedCount }} نظر انتخاب‌شده</v-btn>
      <v-btn
          v-if="selectedCount"
          depressed
          small
          color="success white--text"
          class="rounded-lg"
          :loading="bulkLoading"
          @click="bulkModerate('approve')"
      >تایید {{ selectedCount }} نظر انتخاب‌شده</v-btn>
    </v-card-title>
    <v-card-text>
      <m-datatable
        :headers="headers"
        :apiUrl="url"
        :filters.sync="filters"
        ref="datatable"
        show-select
        @click:row="openDetailDialog"
      ></m-datatable>
    </v-card-text>

    <comment-moderation-dialog
      :item="item"
      :detailDialog.sync="detailDialog"
      @statusChanged="$refs.datatable.getDataFromApi()"
    />
  </v-card>
</template>

<script>
import CommentModerationDialog from "./CommentModerationDialog.vue";

export default {
  name: "CommentModerationList",
  components: { CommentModerationDialog },
  data() {
    return {
      filters: {},
      detailDialog: false,
      item: null,
      bulkLoading: false,
      selectedCount: 0,
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle("مدیریت نظرات");
    },
    url() {
      return "shop/adminComments";
    },
    headers() {
      return [
        { text: "محصول", value: "product_name" },
        { text: "کاربر", value: "customer_name" },
        { text: "موبایل", value: "customer_phone" },
        { text: "متن نظر", value: "text" },
        {
          text: "وضعیت",
          value: "status",
          items: [
            { text: "در انتظار تایید", value: "pending" },
            { text: "تایید شده", value: "approved" },
            { text: "رد شده", value: "rejected" },
          ],
        },
        { text: "تاریخ", value: "created_at", type: "date" },
      ];
    },
  },
  mounted() {
    this.$watch(
      () => this.$refs.datatable.selectedItems.length,
      (val) => {
        this.selectedCount = val;
      }
    );
  },
  methods: {
    openDetailDialog(item) {
      this.item = item;
      this.detailDialog = true;
    },
    bulkModerate(action) {
      const ids = this.$refs.datatable.selectedItems.map((o) => o.id);
      if (!ids.length) return;

      this.bulkLoading = true;
      this.request({
        url: this.endpoint("shop/adminComments/bulkModerate"),
        method: "post",
        data: { ids, action },
        success: () => {
          this.bulkLoading = false;
          this.$refs.datatable.selectedItems = [];
          this.$refs.datatable.selectedValues = [];
          this.$refs.datatable.getDataFromApi();
        },
        error: () => {
          this.bulkLoading = false;
        },
      });
    },
  },
};
</script>
